import React, {useState} from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Row, Col } from "react-bootstrap/";

import { AuthorizationCheck } from '../../utils/AuthorizationCheck';
import PricingPlans from '../shared/PricingPlans';
import appConfig from '../../config/app.js';

const SelectAccount = ({auth}) => {
    const [searchId, setSearchId] = useState(null);
    
    const urlParams = useLocation().search;
    const parts = urlParams.split('?');

    if (parts.length >= 2 && searchId === null) {
        const keyValuesArr = parts[1].split('&');

        keyValuesArr.forEach(param => {
            const [key, value] = param.split('=');
            if (!value) return;
            const decodedValue = decodeURIComponent(value);
            switch (key) {
                case 'search_id':
                    setSearchId( decodedValue );
                    break;
                default:
                    break;
            }
        });
    }

    if ( AuthorizationCheck(auth) ) {
        return ( 
            <>
                {/*MOBILE*/}
                
                {/*DESKTOP*/}
                <div className="mt-5">      
                    <div className="row mx-0">                        
                        <div className="col-1"></div>
                        <div className="col-10 primary-font-color">
                            <Row style={{ paddingTop: "20px", overflow:"hidden" }}>
                                <Col xs={12} >       
                                        
                                    <Row className="text-center" style={{ paddingTop: "20px", fontSize:"2em", lineHeight: "1em" }}>
                                        <Col>Select Account</Col>
                                    </Row>     
                                    <div className="row text-center" >
                                        <div className="col-12 mt-3">
                                            {appConfig.pricing.pricingText.goal}
                                        </div>
                                    </div>
                                    
                                    <PricingPlans 
                                        auth={auth}
                                        searchId={searchId}
                                        showToggle={true}
                                        isOnboarding={false}
                                    />
                                    
                                </Col>                            
                            </Row>
                            
                        </div>    
                    </div>
                </div>
            </>
        ); 
    }
    else {
        return (<>Please wait</>);
    }               
        
};

function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(SelectAccount);
